import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MarkdownRenderer = ({ children }) => {
  return (
    <ReactMarkdown
      components={{
        a: (props) => (
          <a className="underline" {...props}>
            {props.children || props.href}
          </a>
        ),
        blockquote: (props) => (
          <blockquote
            className="border-l-4 pl-4 italic opacity-90"
            {...props}
          />
        ),
        code: ({ children, inline, ...props }) =>
          inline ? (
            <code className="bg-gray700 rounded-sm px-1 py-0.5" {...props}>
              {children}
            </code>
          ) : (
            <div className="my-2 overflow-x-auto">
              <pre className="bg-gray900 rounded-sm p-3">
                <code {...props}>{children}</code>
              </pre>
            </div>
          ),
        h1: (props) => (
          <h1 className="mt-3 mb-1 text-xl font-bold" {...props} />
        ),
        h2: (props) => (
          <h2 className="mt-3 mb-1 text-lg font-bold" {...props} />
        ),
        h3: (props) => (
          <h3 className="mt-2 mb-1 text-base font-bold" {...props} />
        ),
        h4: (props) => (
          <h4 className="mt-2 mb-0.5 text-sm font-bold" {...props} />
        ),
        hr: (props) => (
          <hr className="my-3 border-grayTrue600" {...props} />
        ),
        li: (props) => <li className="list-item" {...props} />,
        ol: (props) => <ol className="my-2 list-decimal pl-4" {...props} />,
        p: (props) => <p className="mb-1" {...props} />,
        strong: (props) => (
          <strong className="font-semibold" {...props} />
        ),
        table: (props) => (
          <div className="my-2 overflow-x-auto">
            <table className="w-full" {...props} />
          </div>
        ),
        tbody: (props) => (
          <tbody className="divide-gray600 divide-y" {...props} />
        ),
        td: (props) => <td className="px-4 py-2" {...props} />,
        th: (props) => <th className="px-4 py-2 text-left font-semibold" {...props} />,
        thead: (props) => <thead className="bg-gray700" {...props} />,
        tr: (props) => <tr className="divide-gray600 divide-x" {...props} />,
        ul: (props) => <ul className="my-2 list-disc pl-4" {...props} />,
      }}
      remarkPlugins={[remarkGfm]}
    >
      {children}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
